import dayjs from "dayjs";
import { SalesDTO } from "../data/SalesDTO";
import { AnalyticsSalesModel, Section } from "./AnalyticsSalesModel";
import { subDays } from "date-fns";

import "dayjs/locale/ru";

export const AnalyticsSalesModelMapper = {
  execute(
    dto: SalesDTO,
    startDate: string,
    endDate: string
  ): AnalyticsSalesModel {
    const sections = [];

    const totalSales = SalesModelMapper.mapTotalSales(dto, startDate, endDate);

    if (totalSales) {
      sections.push(totalSales);
    }

    const diff = SalesModelMapper.mapTotalDiff(dto);

    if (diff) {
      sections.push(diff);
    }

    const amount = SalesModelMapper.mapTotalOrders(dto);

    if (amount) {
      sections.push(amount);
    }

    return {
      sections: sections,
      diffOrder: dto.diff_order,
      diffAmount: dto.diff_amount,
      file: dto.file,
    };
  },
};

const SalesModelMapper = {
  getChange(current: number, end: number): "up" | "neutral" | "down" {
    return current - end > 0 ? "up" : current - end === 0 ? "neutral" : "down";
  },

  getDayDiff(date1: dayjs.Dayjs, date2: dayjs.Dayjs) {
    var diff = date2.toDate().getTime() - date1.toDate().getTime();

    // To calculate the no. of days between two dates
    return diff / (1000 * 3600 * 24);
  },
  mapTotalSales(
    dto: SalesDTO,
    startDate: string,
    endDate: string
  ): Section | undefined {
    try {
      const start = dayjs(startDate);
      const end = dayjs(endDate);

      const diff = this.getDayDiff(start, end);

      const lastPeriod = subDays(start.toDate(), diff);

      if (!("total_sales" in dto)) {
        return;
      }

      const footerText = `${dayjs(lastPeriod).format("DD MMMM YYYY")} - ${dayjs(
        start
      ).format("DD MMMM YYYY")} `;

      const change = this.getChange(
        dto.total_sales.current_amount,
        dto.total_sales.previous_amount
      );

      return {
        title: "Общие продажи",
        value: {
          value:
            dto.total_sales.current_amount.toLocaleString("ru") +
            " " +
            dto.currency_code,
          change: "neutral",
          color: "#040F0F",
        },
        diffValue: {
          value: footerText,
          subValue: `${dto.total_sales.previous_amount.toLocaleString()}${
            dto.currency_code
          }`,
          change: change,
          color: "#040F0F",
        },
      };
    } catch (e) {
      return;
    }
  },
  mapTotalOrders(dto: SalesDTO): Section | undefined {
    try {
      const colorConfig: { [key: string]: string } = {
        up: "#189C4B",
        down: "#C14461",
        neutral: "#E8E8E9",
      };

      if (!("orders_quantity" in dto)) {
        return;
      }

      const prefix = dto.orders_quantity.percent > 0 ? "+" : "";

      return {
        title: "Заказы",
        value: {
          change: this.getChange(dto.orders_quantity.percent, 0),
          value: `Кол-во заказов: ${dto.orders_quantity.quantity}`,
          color: "#040F0F",
        },
        diffValue: {
          change: this.getChange(dto.orders_quantity.percent, 0),
          value: `${prefix}${Math.round(dto.orders_quantity.percent)}%`,
          color: colorConfig[this.getChange(dto.orders_quantity.percent, 0)],
        },
      };
    } catch {
      return;
    }
  },
  mapTotalDiff(dto: SalesDTO): Section | undefined {
    try {
      const colorConfig: { [key: string]: string } = {
        up: "#189C4B",
        down: "#C14461",
        neutral: "#E8E8E9",
      };

      if (!("difference" in dto)) {
        return;
      }

      const prefix = dto.difference.percent > 0 ? "+" : "";

      return {
        title: "Разница",
        value: {
          change: this.getChange(dto.difference.percent, 0),
          value: `${prefix}${Math.round(dto.difference.percent)}%`,
          color: colorConfig[this.getChange(dto.difference.percent, 0)],
        },
        diffValue: {
          change: this.getChange(dto.difference.percent, 0),
          value: `Разница: ${dto.difference.amount.toLocaleString("ru")}${
            dto.currency_code
          }`,
          color: "#656665",
        },
      };
    } catch {
      return;
    }
  },
};
